import {
  FormControl,
  FormHelperText,
  FormLabel,
  Typography,
} from '@mui/material';
import { useContext } from './context';

export function Label({ children, name, required, sx }) {
  const { getError } = useContext();
  const error = getError(name);

  return (
    <FormControl error={Boolean(error)} sx={{ mb: 1, ...sx }}>
      <FormLabel component={Typography} required={required}>
        {children}
      </FormLabel>
      {error && <FormHelperText sx={{ m: 0 }}>{error}</FormHelperText>}
    </FormControl>
  );
}
